<template>
  <v-autocomplete
    :clearable="clearable"
    v-bind="$attrs"
    v-on="$listeners"
    v-model="innerValue"
    clear-icon="clear"
    @change="onChange"
    :items="items"
    :name="randomName"
    :id="randomName"
    :autocomplete="randomName"
    :filter="filterFunc"
  >
    <template v-slot:selection="data">
      {{ $t("enums." + data.item) }}
    </template>
    <template v-slot:item="data">
      <v-list-item-content
        v-text="$t('enums.' + data.item)"
      ></v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: () => undefined,
    },
    items: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      innerValue: null,
      randomName: "",
    };
  },
  watch: {
    value: {
      handler(v) {
        this.innerValue = v;
      },
      immediate: true,
    },
    innerValue: {
      handler(v) {
        this.$emit("update:value", v);
        this.$emit("change", v);
      },
    },
    items: {
      handler(v) {
        if (v) {
          if (!this.clearable) {
            // console.log(this.items, this.clearable)
            if (this.items && this.items.length === 1) {
              this.innerValue = this.items[0];
            }
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.randomName = this.getRandomName();
    console.log("returnObject: ", this.returnObject, this.items);
  },
  methods: {
    onChange(val) {
      this.$emit("change", val);
    },
    getRandomName() {
      return Math.random().toString();
    },
    filterFunc(item, search) {
      return (
        this.$t("enums." + item)
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
  },
};
</script>
